const MIN_CHAR_CODE: number = 32;
const MAX_CHAR_CODE: number = 126;
const MID_CHAR_CODE: number = Math.floor((MIN_CHAR_CODE + MAX_CHAR_CODE) / 2);
const MIN_CHAR: string = String.fromCharCode(MIN_CHAR_CODE);
const MAX_CHAR: string = String.fromCharCode(MAX_CHAR_CODE);

export const MIN_RANK: string = MIN_CHAR;
export const MAX_RANK: string = MAX_CHAR;

export function rankBetween(before: string | null, after: string | null): string {
  const lo: string = before ?? MIN_CHAR;
  const hi: string = after ?? MAX_CHAR;
  if (lo >= hi) {
    return lo + String.fromCharCode(MID_CHAR_CODE);
  }

  let result: string = "";
  let i: number = 0;
  while (true) {
    const loCode: number = i < lo.length ? lo.charCodeAt(i) : MIN_CHAR_CODE;
    const hiCode: number = i < hi.length ? hi.charCodeAt(i) : MAX_CHAR_CODE + 1;

    if (loCode === hiCode) {
      result += String.fromCharCode(loCode);
      i += 1;
      continue;
    }

    const midCode: number = Math.floor((loCode + hiCode) / 2);
    if (midCode === loCode) {
      result += String.fromCharCode(loCode);
      i += 1;
      continue;
    }

    result += String.fromCharCode(midCode);
    return result;
  }
}

export function rankAtEnd(currentMax: string | null): string {
  return rankBetween(currentMax, null);
}

export function rankAtStart(currentMin: string | null): string {
  return rankBetween(null, currentMin);
}
